<template>
  <component
    v-if="subHeader.componentName"
    :is="subHeader.componentName"
  />
    <div
      v-else
      :class="['page-hero', pageSettings.fill]"
    >
        <div class="page-hero__inner">
            <page-header :params="{...params, settings: pageSettings}"/>
        </div>
    </div>
</template>

<script>
import {usePageSettings} from "../composables/usePageSettings";
import {useHeader} from "../composables/useHeader";
import PageHeader from './PageHeader.vue'

export default {
    name: 'PageHero',
    components: {
        PageHeader,
    },
    props: ['params'],
    setup: (props, ctx) => {
      const {pageSettings} = usePageSettings();
      const {subHeader} = useHeader();
        return {
          pageSettings,
          subHeader
        }
    },
}
</script>

<style lang="scss">
.page-hero {
    background-color: var(--c-secondary-200);
    color: #fff;
    min-height: rem(396);
    &.secondary.white {
      background-color: #fff;
      color:var(--c-gray-100);
      .breadcrumbs {
        &__item,
        &__link {
          color: var(--c-gray-500);
          :active {
            color: var(--c-secondary-200);
          }
        }
      }
    }

    .#{$pageTypeSecondary} & {
        background-color: #fff;
        color: initial;
        min-height: rem(320);

        @include tablet {
            min-height: 0;
        }
    }

    @include tablet {
        min-height: rem(300);
    }
    @include mobile {
        min-height: initial;
    }


    .breadcrumbs {
        &__item,
        &__link {
            color: #fff;
        }
    }

    .#{$pageTypeSecondary} & {
        .breadcrumbs {
            &__item,
            &__link {
                color: initial;
            }
        }
    }
}

.page-header {
    background-color: transparent;

    &__title {

        .#{$pageTypeSecondary} &, .#{$pageTypeSecondary} & + .typed {
            font-weight: 500;
            font-size: rem(50);
            line-height: rem(50);
        }
    }

    &__row {
        .#{$pageTypeSecondary} & {
            flex-direction: column;
            align-items: flex-start;
        }
    }
}
</style>